/**
 * The transportation mode for the route.
 */
export var TravelMode;
(function (TravelMode) {
    /**  default mode, same as car or 4w  */
    TravelMode["AUTO"] = "auto";
    /**  car mode  */
    TravelMode["DRIVING"] = "car";
    /**  bike mode  */
    TravelMode["BICYCLING"] = "bike";
    /**  walk mode  */
    TravelMode["WALKING"] = "0w";
    /**  scooter mode  */
    TravelMode["SCOOTER"] = "escooter";
    /**  four wheels mode  */
    TravelMode["FOUR_WHEELS"] = "4w";
    /**  two wheels mode  */
    TravelMode["TWO_WHEELs"] = "2w";
})(TravelMode || (TravelMode = {}));
/**
 * Output format of the route geometry.
 */
export var GeometryType;
(function (GeometryType) {
    /**  Polyline format geometry.  */
    GeometryType["POLYLINE"] = "polyline";
    /**  Polyline6 format geometry.  */
    GeometryType["POLYLINE_6"] = "polyline6";
    /**  Geojson format geometry.  */
    GeometryType["GEOJSON"] = "geojson";
})(GeometryType || (GeometryType = {}));
export var AvoidType;
(function (AvoidType) {
    /**  Avoid toll in route.  */
    AvoidType["TOLL"] = "toll";
    /**  Avoid ferry in route.  */
    AvoidType["FERRY"] = "ferry";
    /**  Avoid highway in route.  */
    AvoidType["HIGHWAY"] = "highway";
})(AvoidType || (AvoidType = {}));
export var OverviewType;
(function (OverviewType) {
    /**  Include full info in oveview  */
    OverviewType["FULL"] = "full";
    /**  Only inlude simplified info in overview  */
    OverviewType["SIMPLIFIED"] = "simplified";
    /**  Not include overview in result */
    OverviewType["FALSE"] = "false";
})(OverviewType || (OverviewType = {}));
export var ApproachType;
(function (ApproachType) {
    /**  route can arrive at the waypoint from either side of the road  */
    ApproachType["UNRESTRICTED"] = "unrestricted";
    /** route will arrive at the waypoint on the driving_side of the region  */
    ApproachType["CURB"] = "curb";
})(ApproachType || (ApproachType = {}));
//# sourceMappingURL=interface.js.map